import React from 'react'
import { Embedly } from '../embedly'
import { NegotiationToolbar } from './negotiation-toolbar'
import { Tagline } from './tagline'

export function VideoHomeCover({ settings, locale }) {
  return (
    <div className="c-row c-row--alpha c-row--collapsed c-row--centered">
      <div className="o-container">
        <div className="o-grid o-grid--gutter">
          <div className="o-grid__item u-pt-delta">
            <div className="c-video-home-cover">
              <Embedly url={settings.homepage_cover_video} />
            </div>
          </div>
          <div className="o-grid__item u-3-of-5-bp3 u-push-1-of-5-bp3">
            <Tagline settings={settings} locale={locale} />
            <NegotiationToolbar />
          </div>
        </div>
      </div>
    </div>
  )
}
